// The gutter every full-width page keeps between its content and the screen
// edge. A phone cannot spare 48px on each side, so the content would be
// squeezed into the middle and anything of a fixed width would push the page
// sideways.
export const PAGE_GUTTER = { xs: "16px", sm: "24px", md: "48px" };
